import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热播榜单
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-[500px] mx-auto">
            实时更新最热门影视排行，看看大家都在追什么
          </p>
        </div>

        <div className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70">
          {rankingData.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-5 py-4 ${
                idx < rankingData.length - 1 ? 'border-b border-background-200/60' : ''
              } hover:bg-background-200/40 transition-colors cursor-pointer`}
            >
              <div className="flex-shrink-0 w-8 text-center">
                {item.rank <= 3 ? (
                  <span className={`text-xl font-bold ${
                    item.rank === 1 ? 'text-accent-500' :
                    item.rank === 2 ? 'text-secondary-400' :
                    'text-primary-500'
                  }`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-lg font-semibold text-foreground-400">
                    {item.rank}
                  </span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500 mt-0.5 block">
                  {item.type}
                </span>
              </div>

              <div className="flex-shrink-0 flex items-center gap-4 text-xs md:text-sm">
                <span className="text-accent-500 font-semibold whitespace-nowrap">
                  {item.score}
                </span>
                <span className={`font-medium whitespace-nowrap ${
                  item.trend.startsWith('↑') ? 'text-primary-500' :
                  item.trend === 'new' ? 'text-accent-500' :
                  'text-secondary-500'
                }`}>
                  {item.trend.startsWith('↑') || item.trend.startsWith('↓')
                    ? item.trend
                    : 'NEW'}
                </span>
                <span className="text-foreground-500 whitespace-nowrap hidden sm:inline">
                  {item.hot}热度
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}